import { Grid } from "@mui/material";
import TextInput from "./TextInput";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";

export const EditTextInfoForm = React.forwardRef(
  (
    props: {
      schema: yup.ObjectSchema<any>;
      fieldName: string;
      value?: string;
      label: string;
      setNewValue: (value: string) => void;
      setOpenConfirmValueEditModal: (open: boolean) => void;
      open: boolean;
      setCanEdit: (canEdit: boolean) => void;
    },
    ref
  ) => {
    const {
      setNewValue,
      setOpenConfirmValueEditModal,
      open,
      schema,
      fieldName,
      label,
      value,
      setCanEdit,
    } = props;
    const {
      control,
      formState: { errors },
      setValue,
      handleSubmit,
      watch,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const data = watch();
    useEffect(() => {
      if (value && data[fieldName] !== value) {
        setCanEdit(true);
      } else {
        setCanEdit(false);
      }
    }, [data]);
    const onMount = () => {
      if (!value) {
        setValue(fieldName, "");
        return;
      }
      setValue(fieldName, value);
    };

    useEffect(() => {
      if (open) onMount();
    }, [open]);

    const onSubmit = (data: any) => {
      const newValue: string | undefined =
        data[fieldName] !== value ? data[fieldName] : undefined;
      if (newValue) {
        setNewValue(newValue);
        setOpenConfirmValueEditModal(true);
      }
    };
    React.useImperativeHandle(ref, () => ({
      async submitForm() {
        await handleSubmit(onSubmit)();
      },
    }));
    return (
      <Grid item>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            overflowY: "auto",
            maxHeight: "80%",
            padding: "1rem",
            width: "100%",
          }}
          className="d-flex flex-column"
        >
          <TextInput
            label={label}
            control={control}
            errors={errors}
            fieldName={fieldName}
            style={{
              width: "100%",
            }}
          />
        </form>
      </Grid>
    );
  }
);
